import { useEffect, useState } from "react";

const FirstOurVisionSection = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const section = document.getElementById("FirstOurVisionSection");
            if (section) {
                const rect = section.getBoundingClientRect();
                if (rect.top <= window.innerHeight && rect.bottom >= 0) {
                    setIsVisible(true);
                }
            }
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll(); // Trigger once on mount

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <section id="FirstOurVisionSection" className="relative w-full min-h-screen bg-black text-white flex items-center justify-center overflow-hidden">
            <div
                className={`container px-4 md:px-6 text-center transition-all duration-700 ease-out transform ${
                    isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
                }`}
            >
                <div className="flex flex-col items-center space-y-4">
                    <div className="space-y-2">
                        <h1 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl lg:text-6xl text-white">
                            Unsere Vision
                        </h1>
                        <p className="mx-auto max-w-[700px] text-zinc-400 md:text-xl">
                            Die Zukunft der Cloud ist <strong>serverless, nachhaltig und Open Source</strong>.
                            Unser Ziel ist es, Unternehmen eine leistungsfähige, sichere und
                            DSGVO-konforme Cloud-Infrastruktur bereitzustellen – betrieben in
                            Deutschland, mit 100% erneuerbarer Energie.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FirstOurVisionSection;
